<template>
 <div>
  <div id="eIMessageTagParent">
    <div id="eITime">{{time}}</div>
    <div id="eIMoney">{{money}}元</div>
  </div>
  <HR style="border:1 dashed #987cb9;" width="95%" color=#DCDCDC SIZE=1></HR>
 </div>
</template>

<script>
 export default {
    // 声明属性，需要从父组件中通过 v-bind:time="" 和 v-bind:money="" 传递参数值过来
    props: {
      time:{type: String},
      money:{type: String},
    },
   data () {
     return {

     }
   },
   components: {

   }
 }
</script>

<style>
#eIMessageTagParent{
    display: flex;
    margin-top: 20px;
  }
#eITime, #eIMoney{
  flex: 1;
  display: flex;
  justify-content: center; /*水平居中*/
  align-items: Center; /*垂直居中*/
  font-size: medium;
  font-weight: bold;
  color: gray;
  line-height: auto;
  text-align: center;
}
 
</style>


// WEBPACK FOOTER //
// src/views/RebateView/ExchangeLog/ExchangeRecordItem.vue